/* eslint-disable @typescript-eslint/no-explicit-any */
import { dash, n0, nz } from "./model";

export type TourRow = { id: string; name: string; year: string; start: number; format?: string; team?: string; m: number; r: number; hs: number; avg: number; sr: number; w: number; bbi?: string };
export type LeagueGroup = { id: string; name: string; rows: TourRow[]; m: number; r: number; w: number };

/** Leagues → tournaments the player has played, newest first. Joins tournament stats with the player's teams. */
export const buildLeagues = (overview: any, teams: any[]): LeagueGroup[] => {
  const teamByTournament = new Map<string, string>();
  teams.forEach((t) => { if (t.tournamentId && t.teamName && !teamByTournament.has(t.tournamentId)) teamByTournament.set(t.tournamentId, t.teamName); });
  const groups = new Map<string, LeagueGroup>();
  nz<any>(overview?.tournamentMiniStats).forEach((s) => {
    const t = s.tournament ?? {};
    const lid = t.leagueId ?? t.leagueName ?? "unknown";
    const g: LeagueGroup = groups.get(lid) ?? { id: lid, name: t.leagueName ?? "Other tournaments", rows: [] as TourRow[], m: 0, r: 0, w: 0 };
    const start = t.startDate ? new Date(t.startDate).getTime() : 0;
    g.rows.push({ id: t.tournamentId, name: t.tournamentName ?? dash, year: start ? String(new Date(start).getFullYear()) : "", start, format: t.matchType, team: teamByTournament.get(t.tournamentId), m: n0(s.matchesPlayed), r: n0(s.runsScored), hs: n0(s.highestScore), avg: n0(s.average), sr: n0(s.strikeRate), w: n0(s.wicketsTaken), bbi: s.bestBowlingFigures ?? undefined });
    g.m += n0(s.matchesPlayed); g.r += n0(s.runsScored); g.w += n0(s.wicketsTaken);
    groups.set(lid, g);
  });
  const out = [...groups.values()];
  out.forEach((g) => g.rows.sort((a, b) => b.start - a.start));
  return out.sort((a, b) => (b.rows[0]?.start ?? 0) - (a.rows[0]?.start ?? 0));
};
